module.exports = __webpack_public_path__ + "static/media/thumb-down.5169879a.svg";